<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div class="d-flex flex-column">
      <app-admin-card-with-title [cardTitle]="basicDataTitle"
                                 [isContentVisible]="!isBasicDataCollapsed" [showToggleButton]="false">
        <div class="row">
          <div class="col-12 col-md-2 d-flex justify-content-start justify-content-xl-center">
            <div class="circle">
              @if (administrator?.picture) {
                <img [src]="administrator?.picture">
              } @else {
                <p>
                  {{ administrator?.firstname?.charAt(0)?.toUpperCase() }}{{
                    administrator?.lastname?.charAt(0)?.toUpperCase()
                  }}
                </p>
              }
            </div>
          </div>
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="firstname"
                             label="{{t('app.common.first.name')}}" [readonly]="!isFormEditable()"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="lastname"
                             label="{{t('app.common.last.name')}}" [readonly]="!isFormEditable()"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="username"
                             label="{{t('app.common.username')}}" [readonly]="!isFormEditable()"></app-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="userId"
                             label="{{t('app.common.id')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="role"
                             label="{{t('app.common.role')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="language"
                             label="{{t('app.common.language')}}" [readonly]="true"></app-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="created"
                             label="{{t('app.common.created')}}" [readonly]="true"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="modified"
                             label="{{t('app.common.modified')}}" [readonly]="true"></app-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  <app-input formControlName="email"
                             label="{{t('app.common.email')}}" [readonly]="!isFormEditable()"></app-input>
                </div>
              </div>
              <div class="col-xl-4 col-6">
                <div class="mb-3">
                  @if (isFormEditable()) {
                    <app-tel-input [formControlName]="'phoneNumber'" [label]="t('app.common.phoneNumber')"
                                   [numberPlaceholder]="t('app.common.phoneNumber')"></app-tel-input>
                  } @else {
                    <app-input formControlName="phoneNumber"
                               label="{{t('app.common.phone.number')}}" [readonly]="!isFormEditable()"></app-input>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>

      @if (administrator?.role === ORGANISERS_ADMINISTRATOR_ROLE) {
        <app-admin-card-with-title [cardTitle]="'Organizacije'"
                                   [isContentVisible]="true" [showToggleButton]="false">
          <div class="pb-16 d-flex justify-content-between">
            <div class="organisation-search">
              <app-search-rounded [name]="organisationSearch"
                                  (searchEmitter)="handleOrganisationSearch($event)"></app-search-rounded>
            </div>
            @if (isSaveVisible()) {
              <div class="d-flex justify-content-end">
                <div class="pe-3">
                  <app-rounded-button [label]="t('app.common.back')"
                                      [btnClass]="'rounded-button--black-outline'" (onClick)="back()"/>
                </div>
                <app-rounded-button [isDisabled]="!isSaveEnabled()"
                                    [label]="t('app.common.save')"
                                    (onClick)="onSave()"
                                    [fullWidth]="false"
                                    [btnClass]="'rounded-button--solid'"
                />
              </div>
            } @else {
              <div class="d-flex justify-content-end mt-3">
                <app-rounded-button [label]="t('app.common.back')"
                                    [btnClass]="'rounded-button--black-outline'" (onClick)="back()"/>
              </div>
            }
          </div>
          <div class="table-responsive">
            <app-sortable-table cssClass="table dark-header table-last-row-no-border" [items]="filteredOrganisations">
              <thead>
              <tr>
                <th scope="col" class="checkbox-col">
                  <input type="checkbox" class="form-check-input"
                         [checked]="allOrganisationsSelected"
                         [indeterminate]="someOrganisationsSelected"
                         (change)="toggleAllOrganisations($event)">
                </th>
                <th scope="col" [sortBy]="['name']" class="name-col">{{ t('organiser.details.name') }}</th>
                <th scope="col" [sortBy]="['website']">{{ t('organiser.details.web') }}</th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (organisation of filteredOrganisations; track organisation.id) {
                  <tr>
                    <td class="text-center">
                      <input type="checkbox" class="form-check-input"
                             [checked]="organisation.selected"
                             (change)="toggleOrganisation(organisation)">
                    </td>
                    <td>{{ organisation.name }}</td>
                    <td>{{ organisation.website }}</td>
                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div>
        </app-admin-card-with-title>
      }
      @if (isSaveVisible() && administrator?.role !== ORGANISERS_ADMINISTRATOR_ROLE) {
        <div class="d-flex justify-content-end mt-3">
          <div class="pe-3">
            <app-rounded-button [label]="t('app.common.back')"
                                [btnClass]="'rounded-button--black-outline'" (onClick)="back()"/>
          </div>
          <app-rounded-button [isDisabled]="!isSaveEnabled()"
                              [label]="t('app.common.save')"
                              (onClick)="onSave()"
                              [fullWidth]="false"
                              [btnClass]="'rounded-button--solid'"
          />
        </div>
      } @else if (administrator?.role !== ORGANISERS_ADMINISTRATOR_ROLE)  {
        <div class="d-flex justify-content-end mt-3">
          <app-rounded-button [label]="t('app.common.back')"
                              [btnClass]="'rounded-button--black-outline'" (onClick)="back()"/>
        </div>
      }
    </div>
  </form>
</ng-container>
